import { render, staticRenderFns } from "./ReleaseListItem.vue?vue&type=template&id=5c3c271d"
import script from "./ReleaseListItem.vue?vue&type=script&lang=js"
export * from "./ReleaseListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports